import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c186142a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oxd-table-card-cell"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "data" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showHeader)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.header.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.item), 1))
}